import { Link } from 'react-router-dom';

export default function Logo() {
    return (
        <Link to="/">
            <img src="/EV_logo.png" width="300px" alt="EV Stories logo in black and green with electric plug icon inside the O."></img>
        </Link>
    );
}